// libs
import React from "react";
import Icon from "@ant-design/icons";

const AllDailyReportSubSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M7.00001 17.1001H15C15.9739 17.1001 16.7667 16.308 16.7667 15.3334V5.33341C16.7667 4.35883 15.9739 3.56675 15 3.56675H7.00001C6.02614 3.56675 5.23334 4.35883 5.23334 5.33341V15.3334C5.23334 16.308 6.02614 17.1001 7.00001 17.1001ZM6.10001 5.33341C6.10001 4.83731 6.50391 4.43341 7.00001 4.43341H15C15.4961 4.43341 15.9 4.83731 15.9 5.33341V15.3334C15.9 15.8295 15.4961 16.2334 15 16.2334H7.00001C6.50391 16.2334 6.10001 15.8295 6.10001 15.3334V5.33341Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M3.66667 15.1H4.33333C4.57256 15.1 4.76667 14.9059 4.76667 14.6667C4.76667 14.4274 4.57256 14.2333 4.33333 14.2333H3.66667C3.17056 14.2333 2.76667 13.8294 2.76667 13.3333V2.66667C2.76667 2.17056 3.17056 1.76667 3.66667 1.76667H11.6667C12.1628 1.76667 12.5667 2.17056 12.5667 2.66667C12.5667 2.9059 12.7608 3.1 13 3.1C13.2392 3.1 13.4333 2.9059 13.4333 2.66667C13.4333 1.69208 12.6405 0.9 11.6667 0.9H3.66667C2.6928 0.9 1.9 1.69208 1.9 2.66667V13.3333C1.9 14.3079 2.6928 15.1 3.66667 15.1Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M8.33333 12.4334H13.6667C13.9059 12.4334 14.1 12.2393 14.1 12.0001C14.1 11.7609 13.9059 11.5667 13.6667 11.5667H8.33333C8.09411 11.5667 7.9 11.7609 7.9 12.0001C7.9 12.2393 8.09411 12.4334 8.33333 12.4334Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M8.33333 15.1002H13.6667C13.9059 15.1002 14.1 14.9061 14.1 14.6668C14.1 14.4276 13.9059 14.2335 13.6667 14.2335H8.33333C8.09411 14.2335 7.9 14.4276 7.9 14.6668C7.9 14.9061 8.09411 15.1002 8.33333 15.1002Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M8.33333 9.76667H13.6667C13.9059 9.76667 14.1 9.57256 14.1 9.33333C14.1 9.0941 13.9059 8.9 13.6667 8.9H8.33333C8.0941 8.9 7.9 9.0941 7.9 9.33333C7.9 9.57256 8.0941 9.76667 8.33333 9.76667Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M8.33333 7.09992H13.6667C13.9059 7.09992 14.1 6.90581 14.1 6.66659C14.1 6.42736 13.9059 6.23325 13.6667 6.23325H8.33333C8.0941 6.23325 7.9 6.42736 7.9 6.66659C7.9 6.90581 8.0941 7.09992 8.33333 7.09992Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="14.6667"
          height="16.0001"
          fill="white"
          transform="translate(2 1)"
        />
      </clipPath>
    </defs>
  </svg>
);

const AllDailyReportSubIcon = (props) => (
  <Icon component={AllDailyReportSubSvg} {...props} />
);

export default AllDailyReportSubIcon;
